<template>
  <section class="hero is-bold app-navbar animated" :class="{ slideInDown: show, slideOutDown: !show }">
    <div class="hero-head">
      <!-- 기본 nav -->
      <nav class="nav" v-if="group_id === undefined">
        <div class="nav-left">
          <div class="title-area is-hidden-mobile" :href="dashboardUrl" @click="clickDashboard">
            <img v-if="checkServiceVersion(2)" :src="svgSrc('ic_platformfy_gray')" style="margin-right:8px">
            <i v-else class="material-icons" style="margin-right:8px">ballot</i>
            <div class="header-service">{{ serviceName }}</div>
            <div v-if="!checkServiceVersion(2)" class="header-title">서비스 관리</div>
          </div>

          <a class="nav-item is-hidden-tablet" @click="clickSliderbar">
            <i class="fa fa-bars" aria-hidden="true"></i>
          </a>
        </div>
        <div class="title-area is-hidden-tablet" :href="dashboardUrl"  @click="clickDashboard">
          <img v-if="checkServiceVersion(2)" :src="svgSrc('ic_platformfy_gray')" style="margin-right:8px">
          <i v-else class="material-icons">ballot</i>
          <div class="header-service">{{ serviceName }}</div>
          <div v-if="!checkServiceVersion(2)" class="header-title">서비스 관리</div>
        </div>

        <div class="nav-right is-flex">
          <div class="flex-align is-hidden-mobile">
            <input-search></input-search>
            <!--<div v-if="isAdmin && !isLaunchpack" class="flex-align" style="margin-left:24px">
              &lt;!&ndash;<div class="button-nav" @click="clickGuide" v-if="vGuide">
                <i class="material-icons primary" style="font-size:20px">error</i>
                <div class="size-13" style="color:#333">서비스 운영가이드</div>
              </div>&ndash;&gt;
              <div class="button-nav" @click="linkInquiry('create')">
                <img class="svg-sub" :src="svgSrc('u_comment')"/>
                <div class="size-13" style="color:#333">런치팩에 문의</div>
              </div>
              <div class="button-nav position-relative" @click="linkInquiry('list')">
                <div class="inq-noti-count" v-if="inqNotiCount>0">{{ inqNotiCount>9 ? 9 : inqNotiCount }}<span
                  v-if="inqNotiCount>9">+</span></div>
                <img class="svg-sub" :src="svgSrc('u_comment-message')"/>
                <div class="size-13" style="color:#333">런치팩 문의목록</div>
              </div>
              <a :href="linkSite" target="_blank" class="button-nav">
                <img class="svg-sub" :src="svgSrc('u_external-link-alt')"/>
                <div class="size-13" style="color:#333">사이트 바로가기</div>
              </a>
            </div>-->
          </div>
          <div class="dim" v-if="vContext" @click="vContext=false"></div>
          <div class="button-user" @click="vContext=!vContext">
            <div class="user-icon-wrapper">
              <img :src="svgSrc('avatar_default')"/>
              <img :src="svgSrc('ic_arrow_down')"/>
            </div>
            <!--<div class="is-hidden-mobile" style="margin-left:8px;font-size:14px">{{ adminName }}</div>-->
            <div class="context-menu" v-show="vContext">
              <div @click="logOut">로그아웃</div>
              <div @click="routerPush(getPath('account'))" v-if="isAdmin">비밀번호 변경</div>
            </div>
          </div>
        </div>
      </nav>
      <!-- 팀관리 nav -->
      <nav class="nav" v-else>
        <div class="nav-left">
          <div class="title-area is-hidden-mobile" :href="dashboardUrl" @click="clickDashboard">
            <i class="material-icons">ballot</i>
            <div class="header-service">{{ groupName }}</div>
            <div class="header-title">팀관리</div>
          </div>
        </div>
      </nav>
    </div>
    <!--<div class="guide-modal">
      <sweet-modal v-if="isAdmin && !isLaunchpack" ref="guideModal" width="800px">
        <service-guide v-if="serviceInfo"  ref="serviceGuide" @onSelected="res => vGuide = res" :isModal="true"></service-guide>
      </sweet-modal>
    </div>-->
  </section>
</template>

<script>
  import { SweetModal } from 'sweet-modal-vue';
  import InputSearch from "../module/common/InputSearch";
  import ServiceGuide from "../page/dashboard/ServiceGuide";
  export default {
    name: 'NavBar',
    components: {
      ServiceGuide,
      InputSearch,
      SweetModal
    },

    props: {
      show: Boolean
    },
    created() {
      if(this.$route.params.group_id) {
        this.$axios.get(this.getUrl('group/')+this.$route.params.group_id).then(res => {
          this.groupName = res.data.name;
        });
      }
      /*this.getCustomerInquiry();
      this.$root.$on('showCustomerInquiryDetail', res=> {
        this.getCustomerInquiry();
      })*/
    },
    data() {
      return {
        groupName: '',
        inqNotiCount: 0,
        vGuide: false,
        vContext: false
      }
    },
    watch: {
      vGuide(n) {
        if(!n) {
          this.$refs.guideModal.close();
        }
      }
    },
    computed: {
      serviceType() {
        let service_type = 1;
        if(this.$store.getters.serviceType) service_type = this.$store.getters.serviceType;
        return service_type;
      },
      group_id() {
        return this.$route.params.group_id;
      },
      dashboardUrl() {
        return (this.isAdmin) ? '/office/admin/dashboard' : '/office/partner/dashboard'
      },
      linkDesign() {
        return location.origin + '/ui/admin/pagedesign'
      },
      linkSite() {
        return this.$store.getters.getServiceSetting.domain;
      },
      serviceName() {
        return this.$store.getters.serviceName;
      },
      adminName() {
        if (this.$route.path.search('/office/admin') > -1)
          return this.$store.getters.admin.name;
        else if (this.$route.path.search('/office/partner') > -1)
          return this.$store.getters.partner.name;
      }
    },
    methods: {
      clickGuide() {
        this.$refs.guideModal.open();
      },
      getCustomerInquiry() {
        if(!this.isAdmin) return;
        this.$axios.get('admin/launchpack/inquiry/customer?page_length=20').then(res=> {
          this.inqNotiCount = res.data.data.filter(i => !i.is_read).length;
        })
      },
      linkInquiry(type) {
        if(type==='create') {
          this.$router.push(this.getPath('launchpack/inquiry/customer/create'));
        }
        else if(type==='list') {
          this.$router.push('/office/admin/launchpack/inquiry/customer');
        }
      },
      clickDashboard() {
        this.$router.push(`/office/${this.$store.getters.mode}/dashboard`);
      },
      clickSliderbar() {
        this.$store.getters.sidebar ? this.$store.commit('setSideBar', false) : this.$store.commit('setSideBar', true);
      },
      logOut() {
        if(confirm('로그아웃 하시겠습니까?')) {
          let token = '';
          let user_type = '';
          if(this.isAdmin) {
            token = this.$store.getters.admin.token;
            user_type = 'admin'
          }
          else {
            token = this.$store.getters.partner.token;
            user_type = 'partner'
          }
          this.$axios.post(`auth/${user_type}/logout`, { token: token}).then(res=>{
            if(res.status===200){
              this.$store.commit('logOut');
              location.reload();
            }
          });
        }
      },
    }
  }
</script>

<style lang="scss">
  @import '~bulma/sass/utilities/initial-variables';
  @import '~bulma/sass/utilities/functions';
  @import '~bulma/sass/utilities/derived-variables';
  @import '~bulma/css/bulma';

  .app-navbar {
    position: fixed;
    min-width: 100%;
    z-index: 1024;
    box-shadow: 0 2px 3px rgba(17, 17, 17, 0.1), 0 0 0 1px rgba(17, 17, 17, 0.1);

    .container {
      margin: auto 10px;
    }

    .nav-right {
      align-items: center;
      flex: 1;
      justify-content: flex-end;
    }
  }

  .hero-brand {
    .vue {
      margin-left: 10px;
      color: #36AC70;
    }
    .admin {
      color: #28374B;
    }
  }

  .nav-item h1 {
    font-size: 1.3rem;
  }

  // .nav {
  //   background: white;
  // }

  // .nav-title {
  //   font-size: 1.3rem;
  //   color: #7a7a7a;
  // }

  .hero .nav {
    background: none;
    box-shadow: 0 1px 0 hsla(0, 0%, 86%, .3);
  }

  .nav, .nav > .container {
    -ms-flex-align: stretch;
    align-items: stretch;
    display: -ms-flexbox;
    display: flex;
    min-height: 3.5rem;
  }

  .nav {
    background-color: #fff !important;
    position: relative;
    text-align: center;
    z-index: 2;
  }

  .nav-center, .nav-left {
    display: -ms-flexbox;
    display: flex;
    align-items: center;
  }

  .nav-left {
    -ms-flex-pack: start;
    justify-content: flex-start;
    overflow: hidden;
    overflow-x: auto;
    white-space: nowrap;
  }

  .nav-left, .nav-right {
    -ms-flex-align: stretch;
    align-items: stretch;
  }

  .nav-center {
    -ms-flex-align: stretch;
    align-items: stretch;
    -ms-flex-positive: 0;
    flex-grow: 0;
    -ms-flex-negative: 0;
    flex-shrink: 0;
    -ms-flex-pack: center;
    justify-content: center;
    margin-left: auto;
    margin-right: auto;
  }

  .nav-center, .nav-left {
    display: -ms-flexbox;
    display: flex;
  }

  .nav-item a, a.nav-item {
    color: #7a7a7a;
  }

  .nav-item, .nav-item a {
    -ms-flex-negative: 0;
    flex-shrink: 0;
  }

  @media screen and (max-width: 768px) {
    .nav-item {
      -ms-flex-pack: start;
      justify-content: flex-start;
    }
  }

  .nav-item, .nav-item a {
    -ms-flex-negative: 0;
    flex-shrink: 0;
  }

  .nav-item {
    -ms-flex-align: center;
    align-items: center;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-positive: 0;
    flex-grow: 0;
    font-size: 1rem;
    -ms-flex-pack: center;
    justify-content: center;
    padding: .5rem .75rem;
  }

  .nav-item h1 {
    font-size: 1.3rem;
  }

  h1, h2, h3, h4, h5, h6 {
    font-size: 100%;
    font-weight: 400;
  }

  .title-area {
    display: flex;
    align-items: center;
    cursor: pointer;
    user-select: none;
    margin: 0 20px 0 10px;
  }

  .title-area i {
    color: #ff5722;
  }

  .header-service {
    font-size: 14px;
    font-weight: bold;
    color: #393e46;
  }

  .header-title {
    margin-left: 4px;
    font-size: 14px;
    color: #bababa;
  }

  .button-header {
    display: flex;
    margin: 4px 12px;
    align-items: center;
    height: 32px;
    margin-right: 8px;
    font-size: 13px;
    color: #363636;
  }

  .button-header i {
    margin-right: 8px;
  }

  .button-header:hover {
    cursor: pointer;
    border-color: #a0a0a0;
  }

  .user-icon-wrapper {
    display: flex;
    align-items: center;
    gap:0 8px;
  }

  .button-user {
    display: flex;
    margin-left: 12px;
    margin-right: 24px;
    align-items: center;
    cursor: pointer;
    height: 49px;
  }

  .button-user-name {
    font-weight: bold;
    font-size: 14px;
    margin-right: 8px;
  }

  .button-user i {
    width: 24px;
    height: 24px;
    line-height: 24px;
    font-size: 18px;
    background-color: #eeeeee;
    border-radius: 50%;
  }

  a {
    color: unset;
  }
  .dim {
    position: fixed;
    top: 50px;
    left: 0;
    width: 100%;
    height: 100vh;
  }
  .context-menu {
    position: absolute;
    top: 49px;
    right: 16px;
    width: 120px;
    box-shadow:0 2px 4px #0006;
    background-color: white;
  }
  .context-menu div {
    padding: 8px;
    font-size: 14px;
  }
  .context-menu div:hover {
    background-color: #e5e5e5;
  }
  .inq-noti-count {
    position: absolute;
    background-color: red;
    color: white;
    border-radius: 100%;
    width: 14px;
    height: 14px;
    line-height: 14px;
    font-size: 10px;
    font-weight: bold;
    right: 10px;
    top: 0px;
  }

  .button-nav {
    cursor: pointer;
    display: flex;
    align-items: center;
    padding-right: 20px;
    height: 32px;
  }
  .button-nav .svg-sub {
    width: 16px;
    height: 16px;
    margin-right: 2px;
  }
  .button-nav:first-child {
    border-right: 1px solid #ddd;
    margin-right: 20px;
  }

  .guide-modal {
    .sweet-modal.is-alert .sweet-content {
      padding: 0;
    }
  }
</style>
